/**
 * COPIED from pages/dev-agent/components/metadataEditor/AutoFixStatusBars.tsx.
 * No store coupling — drives off the shared useAutoFixLoop hook's AutoFixState.
 */
import type { Dispatch, SetStateAction } from "react";
import type { AutoFixState } from "@/hooks/chat/useAutoFixLoop";

export function AutoFixStatusBars({
  autoFixState,
  errorExpanded,
  setErrorExpanded,
  onCancelAutoFix,
  onResetAutoFix,
}: {
  autoFixState: AutoFixState;
  errorExpanded: boolean;
  setErrorExpanded: Dispatch<SetStateAction<boolean>>;
  onCancelAutoFix: () => void;
  onResetAutoFix: () => void;
}) {
  return (
    <>
      {autoFixState.status === "fixing" && (
        <div className="flex items-center justify-between px-4 py-2 border-b bg-ma-warn-soft flex-shrink-0">
          <div className="flex items-center gap-2">
            <div className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-ma-warn-line border-t-transparent" />
            <span className="text-xs font-medium text-ma-warn-text">
              Resolving compilation issues... ({autoFixState.attempt}/
              {autoFixState.maxAttempts})
            </span>
          </div>
          <button
            type="button"
            onClick={onCancelAutoFix}
            className="text-xs text-ma-warn-text px-2 py-0.5 rounded hover:bg-ma-warn-soft"
          >
            Cancel
          </button>
        </div>
      )}
      {autoFixState.status === "success" && (
        <div className="flex items-center justify-between px-4 py-2 border-b bg-ma-ok-soft flex-shrink-0">
          <span className="text-xs font-medium text-ma-ok-text">
            Fixed on attempt {autoFixState.attempt}
            {autoFixState.explanation && ` — ${autoFixState.explanation}`}
          </span>
          <button
            type="button"
            onClick={onResetAutoFix}
            className="text-xs text-ma-ok-text px-2 py-0.5 rounded hover:bg-ma-ok-soft"
          >
            Dismiss
          </button>
        </div>
      )}
      {autoFixState.status === "failed" && (
        <div className="px-4 py-2 border-b bg-ma-err-soft flex-shrink-0">
          <div className="flex items-center justify-between">
            <span className="text-xs font-medium text-ma-err-text">
              Could not resolve after {autoFixState.maxAttempts} attempts.
            </span>
            <div className="flex items-center gap-1">
              {autoFixState.lastError && (
                <button
                  type="button"
                  onClick={() => setErrorExpanded((prev) => !prev)}
                  className="text-xs text-ma-err-text px-2 py-0.5 rounded hover:bg-ma-err-soft"
                >
                  {errorExpanded ? "Collapse" : "Details"}
                </button>
              )}
              <button
                type="button"
                onClick={onResetAutoFix}
                className="text-xs text-ma-err-text px-2 py-0.5 rounded hover:bg-ma-err-soft"
              >
                Dismiss
              </button>
            </div>
          </div>
          {autoFixState.lastError && (
            <div
              className={`mt-1.5 ${errorExpanded ? "" : "max-h-12 overflow-hidden"}`}
            >
              <pre className="text-xs text-ma-err-text whitespace-pre-wrap font-mono leading-relaxed break-words">
                {autoFixState.lastError}
              </pre>
            </div>
          )}
        </div>
      )}
    </>
  );
}
